
/**
 * Transforma a primeira letra da string
 * em maiúscula.
 * 
 * @param {String} value 
 * @returns {String}
 */
export const capitalize = value => (
    value.split(" ").map(seq => `${seq.charAt(0).toUpperCase()}${seq.slice(1).toLowerCase()}`).join(" ")
);
